import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../lib/queryKeys";
import {
  getQueryDetailAnswers,
  getQueryDetails,
  updateQueryDetail,
} from "../../services";

export const useQueryDetailsData = (
  params: Record<string, unknown>,
  enabled = true
) =>
  useQuery({
    queryKey: queryKeys.queryDetails(params),
    queryFn: () => getQueryDetails({ params }),
    enabled,
  });

export const useQueryDetailAnswers = (
  params: Record<string, unknown>,
  enabled = true
) =>
  useQuery({
    queryKey: queryKeys.queryDetailAnswers(params),
    queryFn: () => getQueryDetailAnswers({ params }),
    enabled,
  });

export const useUpdateQueryDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      body,
      params,
    }: {
      body: FormData;
      params: Record<string, unknown>;
    }) => updateQueryDetail(body, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["queryDetails"] });
      queryClient.invalidateQueries({ queryKey: ["queryDetailAnswers"] });
      queryClient.invalidateQueries({ queryKey: ["queryList"] });
    },
  });
};
